import { default as getUser } from "./getUser";

const userApi = {
  getUser,
};

export default userApi;
